import { NavLink } from 'react-router-dom';

import { getDesktopNavSections } from '@/app/shell/navigationManifest';
import { useAppSelector } from '@/hooks/useAppSelector';
import { cn } from '@/utils/cn';

export function Sidebar() {
  const permissions = useAppSelector(state => state.auth.permissions);
  const sections = getDesktopNavSections(permissions);

  return (
    <aside className="hidden lg:block lg:w-[var(--app-shell-sidebar-width)]">
      <div className="sticky top-0 h-dvh border-r border-slate-200/80 bg-slate-50/76 px-3 py-4 backdrop-blur-xl dark:border-slate-800/90 dark:bg-slate-950/68">
        <nav className="h-full space-y-5 overflow-y-auto pr-1">
        {sections.map(section => (
          <div key={section.key} className="space-y-2">
            <p className="px-3 text-[10px] font-semibold uppercase tracking-[0.24em] text-slate-400 dark:text-slate-500">
              {section.label}
            </p>
            <div className="space-y-1 rounded-[1.35rem] border border-slate-200/75 bg-white/78 p-2 shadow-[0_20px_38px_-34px_rgba(15,23,42,0.26)] dark:border-slate-800/90 dark:bg-slate-900/55 dark:shadow-[0_20px_40px_-34px_rgba(2,6,23,0.88)]">
              {section.items.map(item => (
                <NavLink
                  key={item.key}
                  to={item.path}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-[1.05rem] px-3 py-2.5 text-sm font-medium transition',
                      isActive
                        ? 'bg-brand-50 text-brand-800 shadow-[0_14px_24px_-22px_rgba(37,99,235,0.45)] dark:bg-brand-900/28 dark:text-brand-200'
                        : 'text-slate-700 hover:bg-slate-100/90 dark:text-slate-200 dark:hover:bg-slate-800/90'
                    )
                  }
                >
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-slate-100/90 text-slate-500 dark:bg-slate-800/90 dark:text-slate-300">
                    <item.icon className="h-4 w-4 shrink-0" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate">{item.title}</span>
                    {item.description ? (
                      <span className="block truncate text-[11px] font-medium text-slate-400 dark:text-slate-500">
                        {item.description}
                      </span>
                    ) : null}
                  </span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}
        </nav>
      </div>
    </aside>
  );
}
